import { Directive, nextTick } from "vue";
import Swiper, {
    Autoplay,
    EffectFade,
    Lazy,
    Navigation,
    Pagination,
    SwiperOptions,
    Thumbs,
} from "swiper";

Swiper.use([Navigation, Pagination, Thumbs, EffectFade, Lazy, Autoplay]);

type AppSliderHTMLElement = HTMLElement & {
    _appSliderSwiper?: Swiper;
    _appSliderTotalSlides?: number;
};

export type AppSliderOptions =
    | undefined
    | {
          swiperOptions?: SwiperOptions;
      };

const createSlider = (el: AppSliderHTMLElement, options: AppSliderOptions) => {
    const totalSlides = el.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate)",
    ).length;
    el._appSliderTotalSlides = totalSlides;
    el._appSliderSwiper = new Swiper(el, options?.swiperOptions);
};

export const appSliderDirective: Directive<AppSliderHTMLElement, AppSliderOptions> = {
    mounted(el, bindings) {
        createSlider(el, bindings.value);
    },
    unmounted(el) {
        el._appSliderSwiper?.destroy(true, true);
    },
    updated(el, bindings) {
        const totalSlides = el.querySelectorAll(
            ".swiper-slide:not(.swiper-slide-duplicate)",
        ).length;

        if (totalSlides > (el._appSliderTotalSlides || 0)) {
            el._appSliderSwiper?.destroy();
            el._appSliderTotalSlides = totalSlides;

            nextTick(() => {
                createSlider(el, bindings.value);
            });
        } else {
            el._appSliderSwiper?.update();
        }
    },
};
